export const DRIVER_LOCATION_LABEL = 'travel_nerd_email_banner';
export const ENTITY_NAME = 'travel_nerd_email_cta';
export const ENTITY_SECTION = 'travel_nerd_email_banner';
export const ACTION_SUCCESS = 'travel_nerd_email_success';
export const ACTION_ERROR = 'travel_nerd_email_error';
